<div class="step-shell">
  <div class="step-header">
    <h2>{{ 'profile.taxDocumentation' | translate }}</h2>
    <p class="step-subtitle">
      <a class="tax-form-name-link" [href]="originalFormUrl" target="_blank" rel="noopener noreferrer">
        {{ formNameKey | translate }}
      </a>
      {{ residencySuffixKey | translate }}
    </p>
  </div>

  <div class="certification-copy">
    @if (isFullCertificationVisible()) {
      <div class="certification-copy__text-scroll">
        <div class="certification-copy__expanded">
          <p>{{ 'profile.w9CertificationIntro' | translate }}</p>

          <ol class="certification-list certification-list--numbered">
            <li>{{ 'profile.w9CertificationBullet1' | translate }}</li>
            <li>{{ 'profile.w9CertificationBullet2' | translate }}</li>
            <li>{{ 'profile.w9CertificationBullet3' | translate }}</li>
            <li>{{ 'profile.w9CertificationBullet4' | translate }}</li>
          </ol>

          <p>{{ 'profile.w9FullCertificationSigningIntro' | translate }}</p>
          <p>{{ 'profile.w9FullCertificationUsPersonDefinition' | translate }}</p>
          <p>{{ 'profile.w9FullCertificationForeignPerson' | translate }}</p>
        </div>
      </div>
    } @else {
      <p>{{ 'profile.w9CertificationIntro' | translate }}</p>

      <ol class="certification-list certification-list--numbered">
        <li>{{ 'profile.w9CertificationBullet1' | translate }}</li>
        <li>{{ 'profile.w9CertificationBullet2' | translate }}</li>
        <li>{{ 'profile.w9CertificationBullet3' | translate }}</li>
        <li>
          {{ 'profile.w9CertificationBullet4' | translate }}
          <button type="button" class="certification-copy__link-button" (click)="showFullCertification()">
            {{ 'profile.viewFullCertification' | translate }}
          </button>
        </li>
      </ol>
    }
  </div>

  <div class="certification-card">
    <div class="certification-card__header">
      <korviu-checkbox [control]="iCertifyControl()" />
      <span>{{ 'profile.electronicSignatureCetifif' | translate }}</span>
    </div>

    <div class="certification-card__content">
      <p>{{ 'profile.w9CertificationAgreement' | translate }}</p>
      <p>{{ 'profile.date' | translate }} {{ today() }}</p>
    </div>
  </div>

  <korviu-input [label]="'profile.printNameOfSigner' | translate" size="large" [control]="signerNameControl()" />

  <p class="certification-disclaimer">{{ 'profile.taxAdviceDisclaimer' | translate }}</p>
</div>
